export default "__VITE_ASSET__1cPbMzTj__"